import React from 'react';
import { Radio, DatePicker, message } from '@maxtropy/components';
import { Space } from 'antd';
import dayjs from 'dayjs';
import { getMaxRange } from '../../utils';
import { GRANULARITY_OPTIONS } from '../../constants';
import { TrendGranularity } from '../../types';

interface TrendTimeControlsProps {
  granularity: TrendGranularity;
  dateRange: [any, any] | null;
  onGranularityChange: (g: TrendGranularity) => void;
  onDateRangeChange: (range: [any, any] | null) => void;
}

const TrendTimeControls: React.FC<TrendTimeControlsProps> = ({
  granularity,
  dateRange,
  onGranularityChange,
  onDateRangeChange,
}) => {
  const RANGE_MSG_KEY = 'date-range-warning';
  const datePickerFormat = granularity === TrendGranularity.MONTH ? 'YYYY-MM' : 'YYYY-MM-DD';

  const validateDateRange = (dates: [dayjs.Dayjs, dayjs.Dayjs] | null) => {
    if (!dates?.[0] || !dates?.[1]) {
      onDateRangeChange(dates);
      return;
    }
    const maxRange = getMaxRange(granularity);
    const diff =
      granularity === TrendGranularity.MONTH ? dates[1].diff(dates[0], 'month') : dates[1].diff(dates[0], 'day');
    if (Math.abs(diff) > maxRange) {
      message.error({
        content: `最多选择 ${maxRange + 1} ${granularity === TrendGranularity.MONTH ? '个月' : '天'}`,
        key: RANGE_MSG_KEY,
      });
      return;
    }
    onDateRangeChange(dates);
  };

  return (
    <Space size={8} style={{ padding: '24px 0 0' }}>
      <Radio.Group
        optionType="button"
        buttonStyle="solid"
        value={granularity}
        onChange={(e: any) => onGranularityChange(e.target.value)}
      >
        {GRANULARITY_OPTIONS.map(opt => (
          <Radio.Button key={opt.value} value={opt.value}>
            {opt.label}
          </Radio.Button>
        ))}
      </Radio.Group>
      <DatePicker.RangePicker
        value={dateRange}
        onChange={dates => validateDateRange(dates as [dayjs.Dayjs, dayjs.Dayjs] | null)}
        picker={granularity === TrendGranularity.MONTH ? 'month' : 'date'}
        format={datePickerFormat}
      />
    </Space>
  );
};

export default TrendTimeControls;
